import * as React from 'react';
import * as styles from './ImagePicker.css';
import { Helper } from './../../Helper';

import { IAIcon } from '../icon/Icon';
const IC_UPLOAD = require("../../images/upload.png");
const IC_SPINNER = require("../../images/spinner.png");
import { Environment } from '../../services/Environment';
import { LocalizationService } from '../../services/LocalizationService';
import ImageService from '../../services/ImageService';
import { IAPopup } from '../popup/Popup';
import { IAButton } from '../button/Button';
import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global';

export interface IImagePickerProps {
  label?: string;
  helpLabel?:string;
  imageUrl: string;
  imageHeight?: number;
  token: string;
  uploadUrl: string;
  showPreview: boolean;
  tenant?: string;
  environment?: "Development" | "Test" | "Production";
  style?: React.CSSProperties;
  uploadButtomDisabled?: boolean;
  onChange: (text: string) => void;
  getBase64String?: (base64: ArrayBuffer | string, imageName: string) => void;
  modified?: Date;
  previewImageFit?: "cover" | "contain";
  idPicker: string;
  azureUpload?: boolean;
  imageName?: string; // Only for Azure uploads
  previewSpinnerWidth?: number;
}

export interface IImagePickerState {
  isUploading: boolean;
  imageHeight: number;
  showConfirmOverwrite: boolean;
  lastUploadedDate?: Date;
  previewHasLoaded?: boolean;
}

export class IAImagePicker extends React.Component<IImagePickerProps, IImagePickerState> {

  constructor(props: IImagePickerProps) {
    super(props);
    this.state = {
      isUploading: false,
      imageHeight: 0,
      showConfirmOverwrite: false
    };

  }

  public componentDidMount(): void {
    let imageHeight = 0;
    setTimeout(() => {
      let element: any = document.getElementById(`fileInput${this.props.idPicker}`);
      if (element != undefined) {
        imageHeight = element.clientWidth / 16 * 9;
      }
      this.setState({ imageHeight });
    }, 200);
  }

  public componentWillUnmount(): void {
    console.log("Unmont");
    // const fileInput: any = document.getElementById('fileInput');
    // fileInput.files = [];
  }

  private uploadSelecedFile(file: any, overwrite: boolean): Promise<string> {
    return new Promise<string>((resolve) => {
      let fileReader = new FileReader();
      let files = file.files[0];
      fileReader.onload = (event: any) => {
        let url = this.props.uploadUrl;
        if (!this.props.azureUpload) {
          url += `&name=${Helper.removeSpecialCharacters(files.name)}`;
          if (this.props.imageHeight != undefined) {
            url += `&height=${this.props.imageHeight}`
          }
          url += `&overwrite=${overwrite}`;
        }
        if (!!this.props.getBase64String) {
          this.props.getBase64String(fileReader.result, `&name=${encodeURIComponent(Helper.removeSpecialCharacters(files.name))}`);
        }
        let body = `"${event.target.result}"`;
        if (this.props.azureUpload) {
          body = `{"image": "${event.target.result}", "name": "${this.props.imageName}", "extension": "${files.type.indexOf("gif") != -1 ? "gif" : (files.type.indexOf("png") != -1 ? "png" : "jpg")}"}`
        }
        new FetchProxy(url, {
          method: "PUT",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": this.props.token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }),
          body: body
        })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then(function (response) {
          if (!response.ok) {
            throw (response.status);
          } else {
            if (response.status === 204) {
              return ("")
            } else {
              return response.json();
            }
          }
        }).then(response => {
          resolve(response);
        }).catch(() => {
        });
      };
      fileReader.readAsDataURL(files);
    });
  }


  public render(): JSX.Element {
    let imageProxy: string;
    if (this.props.imageUrl) {
      if (ImageService.isUrlTenantInternal(this.props.imageUrl)) {
        imageProxy = Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, this.props.imageUrl, this.state.lastUploadedDate ? this.state.lastUploadedDate.toString().replace(/[^\d]/g, '') : this.props.modified ? this.props.modified.toString().replace(/[^\d]/g, '') : "", "StandardLarge", undefined, true);
      } else {
        imageProxy = this.props.imageUrl;
      }
    }

    return (
      <div
        className={styles.IA_imagePicker}
        id="IAImagePicker"
        style={this.props.style}
      >
        {this.props.label &&
          <label htmlFor={`imagePickerUrl_${this.props.idPicker}`} style={{ float: "left" }}>{this.props.label}</label>
        }
        {!this.props.azureUpload &&
          <input
            id={`imagePickerUrl_${this.props.idPicker}`}
            style={{
              clear: "both",
              marginTop: 9,
              paddingLeft: "10px",
              width: "230px"
            }}
            disabled={this.props.azureUpload}
            type="text"
            placeholder={this.props.azureUpload ? undefined : (new LocalizationService() != undefined ? new LocalizationService().strings.ImagePicker_Placeholder : "")}
            value={this.props.imageUrl != undefined ? this.props.imageUrl : ""}
            onChange={(event: any) => this.props.onChange(event.target.value)}
          />
        }
        {!this.props.azureUpload &&
          <div
            className={styles.IA_imagePickerClearButton}
            style={{
              marginTop: this.props.label != undefined ? 16 : 16
            }}
          >
            <IAIcon
              title="Close"
              size={18}
              color={"#333333"}
              onClick={() => {
                this.props.onChange(undefined);
              }}
            />
          </div>
        }
        <div className={this.state.isUploading ? styles.IA_uploadButton + " " + styles.IA_uploading : styles.IA_uploadButton}
          style={{
            backgroundImage: this.state.isUploading ? `url(${IC_SPINNER})` : `url(${IC_UPLOAD})`,
            clear: this.props.azureUpload ? "both" : "none",
            float: this.props.azureUpload ? "left" : "none",
            marginTop: this.props.azureUpload ? 0 : (this.props.label != undefined ? 28 : 9)
          }}>
          <input
            className={styles.IA_inputfile}
            type="file"
            aria-label="Upload image"
            id={`fileInput${this.props.idPicker}`}
            disabled={this.state.isUploading ? true : this.props.uploadButtomDisabled}
            onChange={() => {
              const fileInput: any = document.getElementById(`fileInput${this.props.idPicker}`);
              this.setState({ isUploading: true });
              this.uploadSelecedFile(fileInput, false).then((imageUrl: string) => {
                if (this.props.azureUpload) {
                  this.props.onChange("");
                  this.setState({ isUploading: false, lastUploadedDate: new Date() });
                } else {
                  if (imageUrl.indexOf("https://") > -1) {
                    this.props.onChange(imageUrl);
                    // fileInput.value = "";
                    this.setState({ isUploading: false, lastUploadedDate: new Date() });
                  } else {
                    this.setState({ showConfirmOverwrite: true });
                  }
                }
              });
            }}
          />
        </div>
        {this.props.helpLabel &&
          <div className={styles.helpLabel}><label style={{ float: "left" }}>{this.props.helpLabel}</label></div>
        }
        {this.props.showPreview && this.props.imageUrl != undefined && this.props.imageUrl != "" &&
          <>
            {!this.state.previewHasLoaded && 
              <div
                className={styles.IA_imagePicker_SpinnerContainer}
                style={{ width: this.props.previewSpinnerWidth ? this.props.previewSpinnerWidth : "100%"}}
              >
                <div 
                  className={styles.IA_imagePicker_Spinner}
                >
                  <IAIcon
                    title="Spinner"
                    size={40}
                    color={"#aaaaaa"}
                  />
                </div>
              </div>
            }
            <img
              className={styles.IA_imagePickerPreview}
              src={imageProxy}
              alt="Image preview"
              style={{
                opacity: this.state.previewHasLoaded ? 1 : 0
              }}
              onLoad={() => this.setState({previewHasLoaded: true})}
            />
          </>
        }
        {this.state.showConfirmOverwrite &&
          <IAPopup
            headline={new LocalizationService().strings.Uploader_Upload_OverwriteConfirmation}
            content={
              <div>
                <IAButton
                  label={new LocalizationService().strings.Uploader_Upload_OverwriteYes}
                  buttonColor={"#333333"}
                  showSpinner={false}
                  onClick={() => {
                    const fileInput: any = document.getElementById(`fileInput${this.props.idPicker}`);
                    this.setState({ showConfirmOverwrite: false });

                    this.uploadSelecedFile(fileInput, true).then((imageUrl2: string) => {
                      this.props.onChange(imageUrl2);
                      // fileInput.value = "";
                      this.setState({ isUploading: false, lastUploadedDate: new Date() });
                    })
                  }}
                  style={{
                    marginTop: 20,
                    float: "left"
                  }}
                />
                <IAButton
                  label={new LocalizationService().strings.Uploader_Upload_OverwriteNo}
                  buttonColor={"#999999"}
                  showSpinner={false}
                  onClick={() => {
                    let fileInput2: any = document.getElementById(`fileInput${this.props.idPicker}`);
                    fileInput2.value = "";
                    this.setState({ isUploading: false, showConfirmOverwrite: false });
                  }}
                  style={{
                    marginTop: 20,
                    marginLeft: 10,
                    float: "left"
                  }}
                />
              </div>
            }
            close={() => {
              let fileInput2: any = document.getElementById(`fileInput${this.props.idPicker}`);
              fileInput2.value = "";
              this.setState({ isUploading: false, showConfirmOverwrite: false });
            }}
          />
        }
      </div>
    );
  }
}